<template>
    <div>
        <div class="breadcrumbs">
            <div class="col-sm-4">
                <div class="page-header float-left">
                    <div class="page-title">
                        <h1>이용내역조회</h1>
                    </div>
                </div>
            </div>            
        </div>

        <b-container fluid class="animated fadeIn">            
            <div class="card">
                <div class="card-header">
                    <strong class="card-title">필요한 내용 쓸것</strong>
                </div>
                <div class="card-body" >
                    <div class="w-25 mb-3 mr-2">                    
                        
                    </div>
                    
                    <div class="mb-3 float-left">
                        <b-row align-h="end" align-v="center">
                            <b-col  md="auto">                                
                                <b-form-group
                                    label="선택 :"
                                    label-for="empState"                                    
                                    :label-cols="2"
                                    :horizontal="true">
                                    <b-input-group>
                                        <b-form-select v-model="searchType">
                                            <option value="0">전체</option>
                                            <option value="1">전화번호</option>
                                            <option value="2">이름</option>
                                        </b-form-select>
                                        <div class="col-xs-3">
                                        <b-form-input size="md" class="ml-2" id="keyword" v-model="keyword" type="text" placeholder="입력"></b-form-input>
                                        </div>
                                    </b-input-group>
                                </b-form-group>                                                                                             
                            </b-col>
                        </b-row>
                    </div>
                    <div class="ml-3 float-right">
                        <b-button class="mb-2" size="md" variant="primary" @click="refreshTable">검색</b-button>
                    </div>                        
                    <div class="mb-3 float-right">
                        <b-row align-h="end" align-v="center">                            
                            <b-col cols="auto" ><strong class="align-middle">이용기간</strong></b-col>
                            <b-col>
                                <datepicker
                                    placeholder="날짜"
                                    :bootstrapStyling="true"
                                    :clearButton="true"
                                    clear-button-icon="fa fa-times"                                        
                                    :calendarButton="true"
                                    calendar-button-icon="fa fa-calendar"
                                    format="yyyy-MM-dd"
                                    :value="fromDate"
                                    v-model="fromDate"                                    
                                    :language="lang"                                    
                                    />
                            </b-col>~ 
                            <b-col>
                                <datepicker
                                    placeholder="날짜"
                                    :bootstrapStyling="true"
                                    :clearButton="true"
                                    clear-button-icon="fa fa-times"                                        
                                    :calendarButton="true"
                                    calendar-button-icon="fa fa-calendar"
                                    format="yyyy-MM-dd"
                                    :value="toDate"
                                    v-model="toDate"
                                    :language="lang"
                                    />
                            </b-col>
                        </b-row>
                                                
                    </div>
                    
                    <b-table style="width: 100%; max-height: 70vh;"      
                        :responsive="true"
                        flex
                        :fixed="true"
                        show-empty
                        empty-text="조회된 내용이 없습니다."
                        empty-filtered-text="조회된 내용이 없습니다."                         
                        ref="historyTable"                                              
                        :small="true"
                        :striped="false" 
                        :bordered="true"  
                        hover                                 
                        :items="useageHistory" 
                        :fields="colums"
                        :per-page="perPage"                        
                        :current-page="currentPage">                        
                    </b-table>
                    
                    <b-pagination size="md" align="center" :total-rows="totalRows" :limit="10" :hide-ellipsis="true" :per-page="perPage" v-model="currentPage" />
                                       
                </div>
            </div>            
        </b-container><!-- .content -->
    </div>
</template>
<script>
import {usageHitory} from '../data/table.js'
import Datepicker from 'vuejs-datepicker'

import historyApi from '../api/useageHistory'
import ResultMessage from '../data/resultMessage'
import {ko} from 'vuejs-datepicker/dist/locale'
import {mapGetters} from 'vuex'

export default {
    name: 'UsageHistory',
    components: {
        Datepicker        
    },    
    data() {
        return {
            colums: usageHitory.fields,            
            // items: [],
            checkedValues : [],
            currentPage: 1,
            perPage: 10,
            totalRows: 1,
            filteredItems: [],
            fromDate: this.calcDate(-7),
            toDate: this.calcDate(0),
            lang: ko,
            searchType: 0,
            keyword: null

        }
    },
    computed: {
        ...mapGetters({
            userAccount: 'userAccount/userAccount'    
        })
    },
    methods : {
        selectedCheckBox : function(orderNo) {
            alert(orderNo);
        },
        useageHistory: function(ctx) {
            let resultMessage = new ResultMessage();    
            let items = null;        
            let queryString = {};
            queryString.corpNo = this.userAccount.corpNo;
            queryString.calcState = 1;            
            queryString.fromDate = this.fromDate.toISOString().split("T")[0];
            queryString.toDate = this.toDate.toISOString().split("T")[0];
            queryString.currentPage = ctx.currentPage;
            queryString.keyword = this.keyword;
            queryString.searchType = this.searchType;
            
            return historyApi.useageHistory(queryString).then(response => {                                
                resultMessage.buildSuccessMessage(response);                
                if(resultMessage.payload != null) {
                    items = resultMessage.payload.contents;
                    this.perPage = resultMessage.payload.perContentCnt;
                    this.currentPage = resultMessage.payload.currentPage;
                    this.totalRows = resultMessage.payload.totalContentCnt;                
                }
                this.filteredItems = items;
                return (items || []);
            }).catch(error => {
                resultMessage.buildErrorMessage(error);
                alert(resultMessage.message);
                return []
            });
        },
        refreshTable: function() {
            this.$refs.historyTable.refresh();
        },
        calcDate : function (daysToAdd) {
            let date = new Date();
            date.setDate(date.getDate() + daysToAdd);            
            return date;//date.toISOString().split("T")[0];
        }
    },
    mounted: function() {
        // 최초 로딩 데이터 조회
        //this.useageHistory();                
    }
}
</script>
<style lang="scss" scoped>
@import '../assets/css/lib/datatable/dataTables.bootstrap.min.css';

.scroll-table {
  width: 100%;      
  
  overflow-x: auto;
}

</style>



// WEBPACK FOOTER //
// src/components/UsageHistory.vue